module.exports = __webpack_public_path__ + "front/img/b16.6224be8f.jpg";